import { WS_PATHS } from "@antares/shared";

export type WsMessage =
  | { type: "stdout"; data: string }
  | { type: "stderr"; data: string }
  | { type: "log"; data: string }
  | { type: "error"; message: string }
  | { type: "close"; reason?: string };

export function createAttachSocket(ns: string, name: string, container?: string): WebSocket {
  const proto = location.protocol === "https:" ? "wss:" : "ws:";
  let url = `${proto}//${location.host}${WS_PATHS.ATTACH(ns, name)}`;
  if (container) url += `?container=${encodeURIComponent(container)}`;
  return new WebSocket(url);
}

export function createLogSocket(ns: string, name: string, container?: string, tail = 200): WebSocket {
  const proto = location.protocol === "https:" ? "wss:" : "ws:";
  const params = new URLSearchParams({ tail: String(tail) });
  if (container) params.set("container", container);
  return new WebSocket(
    `${proto}//${location.host}${WS_PATHS.LOGS(ns, name)}?${params}`
  );
}

export function sendStdin(socket: WebSocket, data: string): void {
  socket.send(JSON.stringify({ type: "stdin", data: btoa(data) }));
}

export function sendResize(socket: WebSocket, cols: number, rows: number): void {
  socket.send(JSON.stringify({ type: "resize", cols, rows }));
}
